// src/cert/fcc.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const FCC = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>FCC प्रमाणन</h1>
                <p>फेडरल कम्युनिकेशन्स कमिशन (Federal Communications Commission)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>FCC म्हणजे काय?</h2>
                    <p>

                        The Federal Communications Commission regulates interstate and international communications by radio, television, wire, satellite and cable in all 50 states, the District of Columbia and U.S. territories. An independent U.S. government agency overseen by Congress, the commission is the United States' primary authority for communications law, regulation and technological innovation. In its work facing economic opportunities and challenges associated with rapidly evolving advances in global communications, the agency capitalizes on its competencies in.

                        Promoting competition, innovation and investment in broadband services and facilities

                        Supporting the nation's economy by ensuring an appropriate competitive framework for the unfolding of the communications revolution

                        Encouraging the highest and best use of spectrum domestically and internationally

                        Revising media regulations so that new technologies flourish alongside diversity and localism

                        Providing leadership in strengthening the defense of the nation's communications infrastructure
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>अमेरिकेत उत्पादन विक्री कायदेशीर होते</li>
                        <li>EMI/EMC टेस्टिंग, FCC ID, DoC, SDoC अनुपालन</li>
                        <li>अन्य उपकरणांशी हस्तक्षेप टाळता येतो</li>
                        <li>दंड, उत्पादन परतावा आणि बाजारातून काढून टाकण्यापासून वाचतो</li>
                        <li>वैश्विक बाजारात (FCC + CE) मान्यता वाढते</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>FCC साठी अर्ज करा</h2>
                    <ApplyForm certification="FCC" />
                </section>
            </div>
        </div>
    );
};

export default FCC;